import { Divider, Grid, Paper } from '@mui/material';
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  ICandidate,
  // getJobCandidateInteraction,
  // getCandidateAggregatedData,
  // getAllInteractions,
  amplitude,
  getJobById,
  InformationReqResponse,
  getInformationReqTemplatesByJob,
  getAllResponses,
  updateRTRfeedback,
  getMappingsByCandidateID,
  IJob,
  ActivityLogSearchResponse,
  markInviteLinkExpired,
} from 'wisestep-api';
import {
  WsTypography,
  WsTypoColors,
  WsColors,
  WsTypoVariants,
  getHoursOld,
  ScrollableTabs,
  TabTextVariant,
} from 'wisestep-base';

import { useWorkspaceContext } from '../../../../context/WorkspaceContext';
import conversationWidgetStore from '../../../../features/conversationWidget/store/conversationWidgetStore';
// import IMappingFormState from '../../../../features/conversationWidget/types/IMappingFormState';
// import { JobsCrmDefaultRequest } from '../../../../features/jobsCrm/components/requests/JobsCrmDefaultRequest';
import NoSubmissionSVG from '../../../../images/NoSubmission.svg';
import { getCachedJob } from '../../../../utils/cacheService';
// import { useConversationWidgetStore } from '../../../../utils/useConversationWidgetStore';
// import { updateMapping } from '../../../conversationWidget/utils/saveMapping';
import { rtrAmplitudeEvents } from '../../../conversationWidget/utils/rtrHelper';
import { useCandidateViewData } from '../../utils/CandidateViewContext';
import { getActivityForCandidateIdAndJobId, mappingTabNames } from '../../utils/helper';
import TimeLine from '../activityLogs/components/timeLine/TimeLIne';
import { CandidateInformationRequest } from '../childComponets/CandidateInformationRequest/CandidateInformationRequest';
import JobList from '../childComponets/jobList/JobList';
import Resizable from '../childComponets/resizable/Resizable';
import NoPreview from '../documents/components/NoPreview';

import MappingBanner from './MappingBanner';
import QuestionResponseTable from './QuestionResponseTable';
// import MappingConversation from './MappingConversation';
import RTRRequestMappingStatus from './RTRRequestMappingStatus';

interface IQuestionResponse {
  question: string;
  answer: string;
}
const Mappings = () => {
  const workspace = useWorkspaceContext();
  const [candidateInteraction, setCandidateInteraction] = useState<ICandidate | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [dragValue, setDragValue] = useState<boolean>(true);
  const [questionResponse, setQuestionResponse] = useState<IQuestionResponse[]>([]);
  const [params] = useSearchParams();

  const { candidateViewData } = useCandidateViewData();
  const updateSelectedJob = conversationWidgetStore((state) => state.updateSelectedJob);
  const [interactionActivity, setInteractionActivity] = useState<ActivityLogSearchResponse[]>([]);
  // const activityConversation = useConversationWidgetStore((state) => state.activityConversation);

  const [getRTRTemplateData, setRTRTemplateData] = useState<InformationReqResponse>();

  const [jobs, setJobs] = useState<IJob[]>([]);
  const [jobId, setJobId] = useState<string>();
  const [index, setIndex] = useState<number>(0);
  const selectedIndex = (index: number) => setIndex(index);
  sessionStorage.removeItem('sessionCandidateProfileRedirectUrlCorpHiring');

  const corphiringTemplate = params.get('corphiringTemplate');
  useEffect(() => {
    if (corphiringTemplate && corphiringTemplate === 'informationrequestTemplate') {
      setIndex(1);
    }
  }, [corphiringTemplate]);

  // const objectRTRExpired = {
  //   downloadSource: 'NOT_SPECIFIED',
  //   recruiterActivity: {
  //     actions: ['RTR Expired'],
  //     results: [],
  //   },
  // };

  // const [formState] = useState<IMappingFormState>({
  //   resumeURl: null,
  //   openCvView: false,
  //   candidateInfo: activityConversation ?? candidateInteraction,
  //   candidateResumes: [],
  //   disableSubmit: false,
  //   results: [],
  //   actions: [],
  //   jobForUpdate: null,
  // });

  const onSelect = async (jobId: string) => {
    setJobId(jobId);
    // const res = await getActivityForCandidateIdAndJobId(candidateViewData?.id, jobId);
    // setInteractionActivity(res);
    const jobData = jobs.find((job) => job.id === jobId);
    if (jobData && candidateInteraction) {
      setCandidateInteraction({
        ...candidateInteraction,
        jobId: jobData?.id ?? null,
        jobCode: jobData?.jobCode ?? null,
        companyName: jobData?.companyName ?? null,
        modifiedOn: jobData?.createdOn?.toString() ?? null,
        mappedJobTitle: jobData?.title ?? null,
        jobAccountManagerName: jobData?.accountManagerName ?? null,
        jobAccountManagerEmail: jobData?.accountManagerEmail ?? null,
      });
    }
    // try {
    //   const req = await getJobCandidateInteraction(interactionId);
    //   const interaction = req.data;
    //   getRTRMappingStatusData(interaction as ICandidate);
    //   setCandidateInteraction(interaction);
    // } catch (error) {
    //   console.error('Error fetching interaction data:', error);
    // }
    amplitude('CandidateView_Mapping_Select', {
      clickedOn: 'Select Mapping',
      pageName: 'candidate-layout',
      pageUrl: window.location.href,
    });
  };

  const getRTRMappingStatusData = async (interaction: ICandidate) => {
    try {
      await getInformationReqTemplatesByJob(interaction?.jobId ?? '');

      const responsesResponse = await getAllResponses(
        interaction.candidateId + '_' + interaction.jobId,
        interaction.jobId as string,
        interaction.recruiterId ?? ''
      );

      let RtrData = responsesResponse.data.filter(
        ({ informationReqTemplate }) => informationReqTemplate.rtrTemplate
      );
      if (RtrData.length > 0) {
        const sentRtr = RtrData.find((rtr) => rtr.rtrFeedback && rtr.rtrFeedback !== '');
        if (sentRtr) {
          if (sentRtr.rtrFeedback === 'RTR Requested') {
            const expiryHours = getHoursOld(sentRtr.requestedOn);
            if (expiryHours > 72) {
              const responseData = await updateRTRfeedback({
                id: sentRtr.id,
                rtrFeedback: 'RTR Expired',
              });
              rtrAmplitudeEvents('rtr_expire', 'RTR expired', workspace);
              if (responseData) {
                await markInviteLinkExpired(sentRtr.id);
                RtrData = [responseData?.data];
                setRTRTemplateData(responseData?.data);
              }
            } else {
              setRTRTemplateData(sentRtr);
            }
          } else {
            setRTRTemplateData(sentRtr);
          }
        } else {
          setRTRTemplateData(RtrData?.[0]);
        }
      }
    } catch (error) {
      console.error('Error fetching templates:', error);
    }
  };

  useEffect(() => {
    setLoading(true);
    const jobId = params.get('jobId');
    const fetchJobById = async () => {
      try {
        if (jobId) {
          const response = await getJobById(jobId);
          response?.data && updateSelectedJob(response.data);
        }
      } catch (error) {
        console.error('Error fetching job:', error);
      }
    };
    fetchJobById();
    (async () => {
      if (candidateViewData) {
        const cachedJob = getCachedJob();
        const response = await getMappingsByCandidateID(
          candidateViewData?.id ?? '',
          cachedJob?.id ?? ''
        );
        const uniqueMapping = response.data;
        const job = jobId ? uniqueMapping.find((job) => job.id === jobId) : uniqueMapping?.[0];
        setJobs(uniqueMapping);
        setJobId(job?.id);
        if (candidateViewData) {
          setCandidateInteraction({
            ...candidateViewData,
            jobId: job?.id,
            jobCode: job?.jobCode,
            companyName: job?.companyName,
            modifiedOn: job?.createdOn?.toString(),
            mappedJobTitle: job?.title,
            jobAccountManagerName: job?.accountManagerName ?? null,
            jobAccountManagerEmail: job?.accountManagerEmail ?? null,
          });
        }
        setLoading(false);
      }
    })();
  }, [candidateViewData, params, updateSelectedJob]);

  useEffect(() => {
    if (jobs.length > 0 && jobId) {
      onSelect(jobId);
    }
  }, [jobs, jobId]);

  useEffect(() => {
    if (candidateInteraction) {
      getRTRMappingStatusData(candidateInteraction);
    }
  }, [candidateInteraction]);

  useEffect(() => {
    const fetchActivity = async () => {
      try {
        const res = await getActivityForCandidateIdAndJobId(candidateViewData?.id, jobId);
        if (res) {
          setInteractionActivity(res);
          setQuestionResponse(
            res
              .flatMap((item) => item.activities)
              .sort((a, b) => new Date(b.modifiedOn).getTime() - new Date(a.modifiedOn).getTime())
              .at(0).questionResponse
          );
        }
      } catch (error) {
        console.error('Error fetching activity:', error);
      }
    };

    fetchActivity();
  }, [candidateViewData?.id, jobId]);

  // const loadMoreActivity = async () => {
  //   try {
  //     if (candidateViewData??.id) {
  //       setLoading(true);
  //       // const res = await getAllInteractions(candidateViewData??.id);
  //       // setCandidateInteractions(res.data);
  //       setloadMappings(false);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching more activity:', error);
  //     setloadMappings(false);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const noMappings: boolean = jobs.length === 0;
  // const conversationStateValue: IConversationState = useMemo(() => {
  //   return {
  //     candidate: candidateViewData?.jobInteraction
  //       ? candidateViewData?.aggregationData?.jobInteraction
  //       : candidateViewData?,
  //     currentUser: loggedInUser,
  //     candidateLocation: null,
  //     candidatePreferredLocations: [],
  //     recentJobMappings: [],
  //     autoSaveDisabledSettings: null,
  //     autoSaveAllowed: true,
  //     getDailyConversationCount: null,
  //     totalConversationPermanentCount: null,
  //     messageAndInteractionPipeline: statusActionPipeline,
  //   };
  // }, [
  //   candidateViewData?.aggregationData?.jobInteraction,
  //   candidateViewData?,
  //   loggedInUser,
  //   statusActionPipeline,
  // ]);

  return (
    <Resizable
      leftPanel={
        noMappings ? (
          <Grid
            container
            rowSpacing={1}
            px={2}
            py={2.2}
            sx={{
              backgroundColor: WsColors.White,
            }}
            height="100%"
            id="leftPaneNoMappings"
          >
            <Grid item xs={12}>
              <Divider sx={{ mb: 1 }} />
              <Grid
                sx={{
                  height: '550px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                <img
                  src={NoSubmissionSVG}
                  alt="No Candidate ?"
                  height={130}
                  width={140}
                  style={{ marginLeft: '15px' }}
                />
                <Grid item sx={{ marginLeft: '20px' }} mt={2}>
                  <WsTypography variant={WsTypoVariants.SUB_TITLE} bold={true}>
                    No Mappings
                  </WsTypography>
                </Grid>
                <Grid item sx={{ marginLeft: '10px' }} mt={1}>
                  <WsTypography color={WsTypoColors.SECONDARY} variant={WsTypoVariants.SUB_TITLE}>
                    Candidate is not mapped to any Job.
                  </WsTypography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <JobList
            jobs={jobs}
            isMappings={true}
            onSelect={onSelect}
            loadMoreText={'Load more mappings'}
            selectedJob={jobId}
          />
        )
      }
      rightPanel={
        noMappings ? (
          <NoPreview text={'mapping'} />
        ) : (
          <Paper variant="outlined" sx={{ mt: 1, p: 1 }}>
            <Grid container id="rightPaneMappings">
              <Grid item xs={12}>
                {candidateInteraction && (
                  <MappingBanner interaction={candidateInteraction} isMapping={true} />
                )}
              </Grid>
              <Grid item xs={12} mb={1}>
                <ScrollableTabs
                  scrollList={mappingTabNames}
                  getTabIndex={selectedIndex}
                  variant={TabTextVariant.SUB_TITLE}
                  defaultValue={index}
                  visibleScrollbar={true}
                  scrollButtons={false}
                />
              </Grid>
              {candidateInteraction && questionResponse && questionResponse.length > 0 && (
                <QuestionResponseTable
                  candidateInteraction={{
                    ...candidateInteraction,
                    questionResponse: questionResponse,
                  }}
                />
              )}
              {index === 0 && (
                <Grid item xs={12} minHeight={550}>
                  {/* <ActivityLogs
                  showAdvancedFilters={false}
                  activityType={'INTERACTIONS'}
                  jobId={jobId}
                /> */}
                  {interactionActivity?.length ? (
                    interactionActivity.map((activity) => (
                      <TimeLine
                        key={`${String(activity.date)}-${candidateViewData?.candidateId}`}
                        onclick={() => {}}
                        activity={activity}
                      />
                    ))
                  ) : (
                    <></>
                  )}
                  {/* {candidateInteraction && (
                    <MappingConversation interaction={candidateInteraction} />
                  )} */}
                </Grid>
              )}
              {index === 1 && (
                <>
                  {candidateInteraction && getRTRTemplateData && (
                    <Grid item xs={12} p={2}>
                      <RTRRequestMappingStatus
                        initialRTRData={getRTRTemplateData}
                        candidateInteractionData={candidateInteraction}
                        isMapping={true}
                        selectedJob={jobId ?? ''}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <CandidateInformationRequest
                      candidate={candidateInteraction}
                      isMapping={true}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Paper>
        )
      }
      defaultSizes={[25, 75]}
      minSize="20%"
      maxSize="80%"
      isLoading={loading}
      pseudoDragValue={dragValue}
      setPseudoDragValue={setDragValue}
    />
  );
};
export default Mappings;
